import { ProductParagraph, Spacing } from '@issuu/silkscreen';
import React from 'react';
import styled, { css } from 'styled-components';
const QuoteBlock = styled.blockquote `
    font-style: italic;
    position: relative;

    &::before {
        content: '“';
        font-size: 1.8em;
        position: absolute;
        left: -0.6em;
        top: -0.2em;
    }

    ${props => props.noClosingQuote
    ? ''
    : css `
                  &::after {
                      content: '”';
                      font-size: 1.8em;
                      position: absolute;
                      bottom: -0.4em;
                  }
              `};

    > p {
        /* Override ProductParagraph so it shows correctly */
        display: inline;
    }
`;
const Quote = props => (React.createElement(Spacing, { bottom: 4, top: 4 },
    React.createElement(QuoteBlock, { ...props },
        React.createElement(ProductParagraph, { step: "2" }, props.children))));
export default Quote;
//# sourceMappingURL=Quote.js.map